import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchProducts(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/products/", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchProduct(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/products/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    editProduct(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/products", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteProduct(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/products", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    updateProductRecord(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/products/record", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteProductRecord(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/products/record", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteProductDocument(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/products/document", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    checkDuplicateProductName(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/products/check-name", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  }
};
